import React from 'react';
import { HARVEST_OPTION_KEY } from "../../pages/PreferencePage/utils";
import stylesComponent from "./style.module.scss";

interface IProps {
    keys?: any
    visible?: boolean
    operation: any
}

const NoteDetail: React.FC<IProps> = ({ keys = {}, visible = false, operation }) => {
    const isShow = keys[HARVEST_OPTION_KEY.NOTE] || visible;

    if (!isShow)
        return null;

    const { note = '' } = operation;

    if (!note || note.length === 0)
        return null;

    return <div className={stylesComponent.section}>
        <span className='text-comment whitespace-pre-line pb-1'>{note}</span>
    </div>;
};

export default NoteDetail;
